import {
  CareerSiteBrandConfigurationResponse,
  CareerSiteSettings,
} from 'api-clients/monolith';
import { FeatureFlagContext } from 'contexts/feature-flag-context';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { AuthControl } from 'components/auth-control';
import { DesktopNav } from 'components/desktop-nav';
import { LanguageSelector } from 'components/language-selector';

import { ChatAgentWidget } from './chat-agent-widget';

export interface NavProps {
  brandName: string;
  logoUrl: string | null | undefined;
  showWidgetByDefault: boolean;
  showChatAgentWidget: boolean;
  chatAgentConfig: {
    agentId?: string;
    widgetUiUrl?: string;
    connectionUrl?: string;
  };
  ssoEnabled: CareerSiteSettings['sso_enabled'];
  ssoDetails: CareerSiteBrandConfigurationResponse['sso'];
  configuredLanguages?: CareerSiteBrandConfigurationResponse['configured_languages'];
}

export function Nav({
  brandName,
  logoUrl,
  showWidgetByDefault,
  showChatAgentWidget,
  chatAgentConfig,
  ssoEnabled,
  ssoDetails,
  configuredLanguages,
}: NavProps) {
  const {
    featureFlags: { careerSiteSettings },
  } = useContext(FeatureFlagContext);

  return (
    <header className="relative sticky top-0 z-50 flex h-16 items-center bg-white px-4">
      <div className="absolute left-1/2 -translate-x-1/2 transform">
        <DesktopNav brandName={brandName} logoUrl={logoUrl} />
        {showChatAgentWidget && showWidgetByDefault && (
          <ChatAgentWidget chatAgentConfig={chatAgentConfig} />
        )}
      </div>

      <div className="ml-auto flex items-center gap-2">
        {ssoDetails?.sso_enabled &&
          ssoEnabled &&
          ssoDetails.user_details?.email && (
            <span className="rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
              <FormattedMessage
                defaultMessage="Internal Career Site"
                description="Badge shown in the navigation bar when an employee is logged into the internal career site via SSO"
              />
            </span>
          )}
        {careerSiteSettings && (
          <LanguageSelector configuredLanguages={configuredLanguages} />
        )}
        {ssoDetails?.sso_enabled && ssoEnabled && (
          <AuthControl ssoUserDetails={ssoDetails.user_details} />
        )}
      </div>
    </header>
  );
}

Nav.Skeleton = function NavSkeleton() {
  return (
    <div className="container flex h-16 justify-center p-6">
      <DesktopNav.Skeleton />
    </div>
  );
};
